"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameSEOToJSON = exports.OWGameSEOFromJSONTyped = exports.OWGameSEOFromJSON = void 0;
var runtime_1 = require("../runtime");
function OWGameSEOFromJSON(json) {
    return OWGameSEOFromJSONTyped(json, false);
}
exports.OWGameSEOFromJSON = OWGameSEOFromJSON;
function OWGameSEOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'metaTitle': !(0, runtime_1.exists)(json, 'metaTitle') ? undefined : json['metaTitle'],
        'metaDescription': !(0, runtime_1.exists)(json, 'metaDescription') ? undefined : json['metaDescription'],
        'keywords': !(0, runtime_1.exists)(json, 'keywords') ? undefined : json['keywords'],
        'ogTitle': !(0, runtime_1.exists)(json, 'ogTitle') ? undefined : json['ogTitle'],
        'ogDescription': !(0, runtime_1.exists)(json, 'ogDescription') ? undefined : json['ogDescription'],
        'ogImage': !(0, runtime_1.exists)(json, 'ogImage') ? undefined : json['ogImage'],
        'twitterCard': !(0, runtime_1.exists)(json, 'twitterCard') ? undefined : json['twitterCard'],
        'twitterTitle': !(0, runtime_1.exists)(json, 'twitterTitle') ? undefined : json['twitterTitle'],
        'twitterDescription': !(0, runtime_1.exists)(json, 'twitterDescription') ? undefined : json['twitterDescription'],
        'twitterImage': !(0, runtime_1.exists)(json, 'twitterImage') ? undefined : json['twitterImage'],
    };
}
exports.OWGameSEOFromJSONTyped = OWGameSEOFromJSONTyped;
function OWGameSEOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'metaTitle': value.metaTitle,
        'metaDescription': value.metaDescription,
        'keywords': value.keywords,
        'ogTitle': value.ogTitle,
        'ogDescription': value.ogDescription,
        'ogImage': value.ogImage,
        'twitterCard': value.twitterCard,
        'twitterTitle': value.twitterTitle,
        'twitterDescription': value.twitterDescription,
        'twitterImage': value.twitterImage,
    };
}
exports.OWGameSEOToJSON = OWGameSEOToJSON;
